import React from 'react';

import PostalCodeAreaTitle from './PostalCodeAreaTitle/PostalCodeAreaTitle';
import PostalCodeAreaForm from './PostalCodeAreaForm/PostalCodeAreaForm';

const PostalCodeArea = props => {
  return (
    <div
      className="PostalCodeArea"
      style={{ ...props.style }}
    >
      <PostalCodeAreaTitle />
      <PostalCodeAreaForm
        handleCode={props.handleCode}
        postalValueFirst={props.postalValueFirst}
        postalValueSecond={props.postalValueSecond}
        handleValueFirst={props.handleValueFirst}
        handleValueSecond={props.handleValueSecond}
      />
    </div>
  );
};

export default PostalCodeArea;
